
import { Tbl_risultatoEdit } from './tbl_risultatoEdit';
import { Tbl_risultatoList } from './tbl_risultatoList';
import { Tbl_risultatoShow } from './tbl_risultatoShow';
import { Tbl_risultatoCreate } from './tbl_risultatoCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_risultatoList,
    edit: Tbl_risultatoEdit,
    show: Tbl_risultatoShow,
    create: Tbl_risultatoCreate,
    icon: MapIcon
};
            